import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

import { newsletter } from "../../utils/routes";
import footerlogo from "../../assets/img/footer.logo.svg";
import footerpin from "../../assets/img/Pin Icon.svg";
import footerplayicon from "../../assets/img/Play store.svg";
import footerfacebookicon from "../../assets/img/facebook icon.svg";
import footerinstagramicon from "../../assets/img/instagram icon.svg";
import footerlinkedinicon from "../../assets/img/linkedin icon .svg";
import footertwittericon from "../../assets/img/twitter icon.svg";
import footerbtn from "../../assets/img/footerbtn.svg";
import { NavLink } from "react-router-dom";
import { Rings } from "react-loader-spinner";
import { ComingSoon } from "../dialogs/ComingSoon";

function Footer() {
  const year = new Date().getFullYear();
  const [email, setEmail] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [emailError, setEmailError] = useState(null);
  const [loading, setLoading] = useState(false);

  const subscribeNewsletter = () => {
    if (email != null && email != "") {
      setLoading(true);
      var object = {
        email: email,
      };
      const getUserRequestDTO = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(object),
      };

      fetch(newsletter, getUserRequestDTO)
        .then((response) => response.json())
        .then((data) => {
          setLoading(false);
          if (data.statusCode == 0) {
            setSuccessMsg(
              "Thank you for subscribing to OneZapp newsletter. We have sent you a confirmation email on your registered email address. If you will not see the email in a few minutes then check your junk mail folder or spam folder"
            );

            setEmail(null);
            setTimeout(function () {
              window.location.reload(1);
            }, 5000);
          } else if (data.statusCode == 456) {
            setSuccessMsg(data.statusDescription);
            setTimeout(function () {
              window.location.reload(1);
            }, 5000);
          }
        });
    } else if (email == null || email == "") {
      setEmailError("Invalid Email address.Please try again");
      return false;
    }
  };

  const validateEmail = (e) => {
    var mail = e.target.value;
    var mailFormet = /^$|^.*@.*\..*$/;
    if (mail.match(mailFormet)) {
      setEmail(mail);
      setEmailError(null);
      $("#footer_btn").attr("disabled", false);
    } else if (!mail.match(mailFormet)) {
      setEmail(null);
      setEmailError("Invalid Email address.Please try again");
      $("#footer_btn").attr("disabled", true);
    }
  };
  function ScrollToTop({ history }) {
    useEffect(() => {
      const unlisten = history.listen(() => {
        window.scrollTo(0, 0);
      });
      return () => {
        unlisten();
      };
    }, []);

    return null;
  }
  return (
    <footer>
      <div className={loading === true ? "overlay" : " "}>
        <p id="loading">
          {loading ? <Rings color="#91298c" height={160} width={160} /> : null}
        </p>
      </div>
      <div className="container ">
        <div className="row"></div>
        <div className="col-12 footer__hr"></div>
      </div>
      {/* section 1 */}
      <div className="container footer__web">
        <div className="row align-items-start">
          <div className="col-3">
            <div>
              <img className="footer__logo" src={footerlogo}></img>
            </div>
            <p className="footer__items">
              {" "}
              <img className="footer__pin" src={footerpin}></img>
              <div>
                <div className="text-lg">E-Processing Systems Pvt. Limited</div>
                <div>
                  E-1, Sehjpal, Near DHA Phase-VIII (Ex-Air Avenue), Lahore Cantt, Pakistan.
                </div>
              </div>
            </p>
          </div>
          <div className="col-1"></div>
          <div className="col-lg-2 col-md-2 footer">
            <h5 className="footer__heading">Company</h5>

            {/* <NavLink
                to="/jobs"
                className="footer"
                activeClassName="active2"
              > */}
            <NavLink
              exact
              to="/about"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              About Us
            </NavLink>
            {/* </NavLink> */}

            <NavLink
              exact
              to="/contact"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              Contact Us
            </NavLink>
            {/* <NavLink
              exact
              to="/careers"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              Careers
            </NavLink> */}
          </div>
          <div className="col-lg-2 col-md-3 footer">
            <h5 className="footer__heading">Links</h5>
            <NavLink
              exact
              to="/faqs"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              FAQs
            </NavLink>
            <NavLink
              exact
              to="/privacy-policy"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              Privacy Policy
            </NavLink>
            <NavLink
              exact
              to="/terms-and-conditions"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              Terms & Conditions
            </NavLink>
            <NavLink
              exact
              to="/charges"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              Schedule of Charges
            </NavLink>
            <NavLink
              exact
              to="/agents"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              OneZapp Agents
            </NavLink>
          </div>
          <div className="col-lg-4 col-md-3 footer__heading">
            <div className="d-flex justify-content-between flex-wrap">
              <div className="mb-4">
                <h5>Download</h5>
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.epSystems.oneZap.android.app"
                >
                  <img className="footerplayicon" src={footerplayicon}></img>
                </a>
              </div>
              <div>
                <h5>Follow us on </h5>
                <div className="footer__icon-div">
                  <div className="footer__shocialicon">
                    <a href="https://www.facebook.com/onezappk" target="_blank">
                      <img src={footerfacebookicon}></img>
                    </a>
                  </div>

                  <div className="footer__shocialicon">
                    <a href="https://twitter.com/onezappk" target="_blank">
                      <img src={footertwittericon}></img>
                    </a>
                  </div>

                  <div className="footer__shocialicon">
                    <a
                      href="https://www.instagram.com/onezapp.pk/"
                      target="_blank"
                    >
                      <img src={footerinstagramicon}></img>
                    </a>
                  </div>
                  <div className="footer__shocialicon">
                    <a
                      href="https://www.linkedin.com/company/onezappk/"
                      target="_blank"
                    >
                      <img src={footerlinkedinicon}></img>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* section 2 */}
      <div className="container footer__web">
        <div className="row">
          <p className="footer__p">
            Subscribe to our email newsletter today to receive updates on the
            latest news and special offers!
          </p>
          <center>
            <div>
              <div>
                <input
                  type="email"
                  className="footer__form-control"
                  aria-describedby="emailHelp"
                  placeholder="Enter your email"
                  onInput={validateEmail}
                  value={email}
                ></input>
                <button
                  id="footer_btn"
                  className="footer__btn"
                  onClick={subscribeNewsletter}
                >
                  {" "}
                  <img className="btn__img" src={footerbtn}></img>
                </button>
              </div>
              <div className={emailError == "" ? "d-none" : ""}>
                <span className="error__msg_email p-3">{emailError}</span>
              </div>

              <span
                className={`success__msg_email p-2 ${successMsg == "" ? "d-none" : ""
                  }`}
                id="success"
              >
                {successMsg}
              </span>
            </div>
          </center>
        </div>
      </div>

      {/* Mobile */}

      {/* section 2  */}
      <div className="container footer__mob">
        <div className="row">
          <div className="col-12 footer__p-mob">
            <p className="footer__items">
              {" "}
              <img className="footer__pin" src={footerpin}></img> E-Processing Systems Pvt. Limited
              E-1, Sehjpal, Near DHA Phase-VIII (Ex-Air Avenue), Lahore Cantt, Pakistan.
            </p>
          </div>
        </div>
        <div className="row align-items-start">
          <div className="col-1 "></div>
          <div className="col-6 footer">
            <h5 className="footer__heading">Company</h5>

            <NavLink
              exact
              to="/about"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              About Us
            </NavLink>

            <NavLink
              exact
              to="/contact"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              Contact Us
            </NavLink>

            {/* <NavLink
              exact
              to="/careers"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              Careers
            </NavLink> */}

            <br></br>
          </div>
          <div className="col-5 footer">
            <h5 className="footer__heading">Links</h5>

            <NavLink
              exact
              to="/faqs"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              FAQs
            </NavLink>
            <NavLink
              exact
              to="/privacy-policy"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              Privacy Policy
            </NavLink>
            <NavLink
              exact
              to="/terms-and-conditions"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              Terms & Conditions
            </NavLink>
            <NavLink
              exact
              to="/charges"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              Schedule of Charges
            </NavLink>
            <NavLink
              exact
              to="/agents"
              className={({ isActive }) =>
                isActive ? "footer__link__active" : "footer__link__inactive"
              }
              onClick={ScrollToTop}
            >
              OneZapp Agents
            </NavLink>
          </div>
        </div>
        <div className="row">
          <div className="col-1 "></div>
          <div className="col-6 footer">
            <h5 className="footer__heading">Follow us on </h5>
            <div className="footer__icon-div">
              <div className="footer__shocialicon">
                <a href="https://www.facebook.com/OneZappPk" target="_blank">
                  <img src={footerfacebookicon}></img>
                </a>
              </div>
              <div className="footer__shocialicon">
                <a href="https://twitter.com/one_zapp" target="_blank">
                  <img src={footertwittericon}></img>
                </a>
              </div>
              <div className="footer__shocialicon">
                <a href="https://www.instagram.com/onezapp.pk/" target="_blank">
                  <img src={footerinstagramicon}></img>
                </a>
              </div>
              <div className="footer__shocialicon">
                <a
                  href="https://www.linkedin.com/company/onezapp"
                  target="_blank"
                >
                  <img src={footerlinkedinicon}></img>
                </a>
              </div>
            </div>
          </div>
          <div className="col-5 footer">
            <h5 className="footer__heading">Download</h5>
            <a
              className="cursor-pointer"
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.epSystems.oneZap.android.app"
            >
              <img className="footerplayicon" src={footerplayicon}></img>
            </a>
          </div>
        </div>
      </div>
      {/* Mobile */}

      <div className="container footer__mob">
        <div className="row">
          <p className="footer__p">
            Subscribe to our email newsletter today to receive updates on the
            latest news and special offers!
          </p>
          <center>
            <div>
              <input
                type="email"
                className="footer__form-control"
                aria-describedby="emailHelp"
                placeholder="Enter your email"
                onInput={validateEmail}
                value={email}
              ></input>
              <button className="footer__btn" onClick={subscribeNewsletter}>
                {" "}
                <img className="btn__img" src={footerbtn}></img>
              </button>
            </div>
            <div className={emailError == "" ? "d-none" : ""}>
              <span className="error__msg_email p-3">{emailError}</span>
            </div>

            <span
              className={`success__msg_email p-2 ${successMsg == "" ? "d-none" : ""
                }`}
              id="success"
            >
              {successMsg}
            </span>
          </center>
        </div>
      </div>
      {/* /////////// */}
      <div className="container ">
        <div className="row"></div>
        <div className="col-12 hr__footer-bottom"></div>
      </div>
      <div className="container footer">
        <div className="row">
          <p className="footer__copyright">
            Copyright &copy; {year} OneZapp | All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
